import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { FeaturesService } from '@libraries/feature-flags';

@Injectable({
  providedIn: 'root',
})
export class CanActivateSuccessGuard implements CanActivate {
  constructor(private features: FeaturesService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.features.isOff('yt-19374-pace-pause-prequal-updates');
  }
}
